export default __webpack_public_path__ + "static/media/plane-icon.83e61274.svg";